module.exports = __webpack_public_path__ + "img/grand-osasis-cancun-room-4.c7fb171b.jpg";